document.addEventListener('DOMContentLoaded', function() {
  var btn = document.querySelector('[data-tear-sheet-btn]');
  if (!btn) return;
  btn.addEventListener('click', function() {
    var d = btn.dataset;
    var imgs = JSON.parse(d.images || '[]');
    var imgHtml = '';
    if (imgs.length > 0) {
      imgHtml = '<div style="display:grid;grid-template-columns:repeat(' + Math.min(imgs.length,2) + ',1fr);gap:4mm;margin-bottom:6mm;">';
      imgs.forEach(function(src) {
        imgHtml += '<img src="' + src + '" style="width:100%;max-height:80mm;object-fit:contain;">';
      });
      imgHtml += '</div>';
    }
    var html = '<!DOCTYPE html><html><head><meta charset="utf-8"><style>'
      + '@page{size:letter portrait;margin:12mm}'
      + 'body{font-family:Arial,sans-serif;font-size:9pt;line-height:1.4;color:#171a17;margin:0;padding:0}'
      + '.hdr{display:flex;align-items:center;justify-content:space-between;border-bottom:2px solid #1e6b1e;padding-bottom:6px;margin-bottom:8px}'
      + '.store{color:#1e6b1e;font-size:11pt;font-weight:700}'
      + '.logo{max-height:48px;max-width:140px;object-fit:contain}'
      + 'h1{font-size:15pt;margin:0 0 4px;line-height:1.2}'
      + '.sku{color:#666;font-size:8pt;margin:0 0 6px}'
      + '.price{font-size:14pt;font-weight:700;color:#1e6b1e;margin:0 0 8px}'
      + '.desc{font-size:8.5pt;line-height:1.4}'
      + '.ftr{margin-top:8px;padding-top:5px;border-top:1px solid #ccc;color:#666;font-size:7.5pt}'
      + '</style></head><body>'
      + '<div class="hdr">' + (d.logo ? '<img class="logo" src="' + d.logo + '">' : '<div class="store">' + d.shop + '</div>') + '<div class="store">' + d.shop + '</div></div>'
      + '<h1>' + d.title + '</h1>'
      + (d.sku ? '<p class="sku">SKU: ' + d.sku + '</p>' : '')
      + '<p class="price">' + d.price + '</p>'
      + imgHtml
      + '<div class="desc">' + d.desc + '</div>'
      + '<div class="ftr">' + d.shop + ' &middot; ' + d.domain + '</div>'
      + '</body></html>';
    var w = window.open('', '_blank', 'width=850,height=1100');
    w.document.open();
    w.document.write(html);
    w.document.close();
    w.focus();
    w.onload = function() { setTimeout(function(){ w.print(); }, 300); };
  });
});
